import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
/**
 * css import
 */
import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import '@/styles/index.scss'

import permission from '@/directive/permission'

Vue.use(VueQuillEditor)
Vue.use(ElementUI)
Vue.directive('permission', permission)
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
